export default __webpack_public_path__ + "static/media/date-night.12213c2f.svg";